<!--
  创建时间：2024/8/21 18:31
  创建人：toyehuang
  文件描述：ImageNews
-->

<template>
  <div class="image-news">
    <el-carousel height="289px" :interval="15000" arrow="never">
      <el-carousel-item v-for="item in list" :key="item.id">
        <div class="image-news-item">
          <Link :to="item.url" class="img-link" target="_blank">
            <img :alt="item.title" :src="item.adImage" class="link-item">
          </Link>
          <p class="image-news-title pl-10">
            <Link :to="item.url" target="_blank" class="title-link text-cut">{{ item.title }}</Link>
          </p>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";

export default {
  name: "ImageNews",
  components: { Link },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    columnCode: {
      type: String
    }
  },
  data() {
    return {
    };
  },
  // 监听属性 类似于data概念
  computed: {
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {}
};
</script>

<style scoped lang="scss">
.image-news{
  width: 463px;
  .image-news-item{
    width: 100%;
    height: 100%;
    position: relative;
    .img-link{
      display: block;
      width: 100%;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &:hover{
      img{
        opacity: 0.8;
      }
    }
    .image-news-title{
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      height: 45px;
      line-height: 45px;
      background-color: rgba(0,0,0,0.4);
      padding-right: 110px;
      font-size: 14px;
      .title-link{
        color: #fff;
        display: block;
      }
    }
  }
  ::v-deep{
    .el-carousel__indicators--horizontal{
      transform: translateX(-100px);
      left: 100%;
      right: 0;
      width: 100px;
      .el-carousel__indicator--horizontal{
        .el-carousel__button{
          width: 6px;
          height: 6px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
